// extracted by mini-css-extract-plugin
export var link = "cP_bV";